



 import React from "react";
 import { PiPhoneFill } from "react-icons/pi";
 import { PiPhoneLight } from "react-icons/pi";
const ContactButton = () => {
  
    
    
    return (
        <a href="tel:00917510266377"  className="btn position-fixed bottom-4 end-4 "
        style={{
         bottom: "40px", 
         right: "20px",   
         width: "60px",   
         height: "60px",  
         zIndex: 1000, 
         color: "white", 
        //  backgroundColor: "#fff", rounded-circle
       }}>
<span className=""> <PiPhoneLight size={24}/></span>

</a>
        
        //  <FaWhatsapp size={24}/>
      
   
    );
  };
  
  export default ContactButton;
  


